module.exports = __webpack_public_path__ + "static/super-admin-inventory-5c708965faea285d4e8298e8bd208e12.png";